var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaolueti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25_1743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8125 10.2495V5.69247C14.8125 5.41633 14.5886 5.19247 14.3125 5.19247H9.63335C9.35721 5.19247 9.13335 4.96862 9.13335 4.69248V1.41672C9.13335 1.14058 8.90949 0.916718 8.63335 0.916718H5.37895C5.22836 0.916718 5.0858 0.984589 4.99085 1.10148L1.4869 5.41532C1.41451 5.50444 1.375 5.61575 1.375 5.73056V9.50308C1.375 10.6077 2.27043 11.5031 3.375 11.5031H5.64547C5.92161 11.5031 6.14547 11.7269 6.14547 12.0031V14.7894C6.14547 15.0656 6.36933 15.2894 6.64547 15.2894H10.838C10.9824 15.2894 11.1196 15.2271 11.2146 15.1184L14.3187 11.5653C14.6371 11.2009 14.8125 10.7334 14.8125 10.2495Z",
    fill: "#00C2FF",
    fillOpacity: 0.4,
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4655 6.64463L11.1894 10.6008C11.0944 10.7155 10.9532 10.7818 10.8043 10.7818H6.59887C6.16006 10.7818 5.93409 10.257 6.23567 9.93822L8.48971 7.55578C8.79129 7.23703 8.56532 6.71215 8.12651 6.71215H2.88303C1.58203 6.71215 0.897896 5.16919 1.7714 4.20503L4.81176 0.84917C4.90654 0.744552 5.04113 0.684875 5.1823 0.684875H8.56749C9.00191 0.684875 9.22966 1.20074 8.93696 1.52175L7.2691 3.35103C6.9764 3.67204 7.20416 4.18791 7.63857 4.18791H13.3102C14.5798 4.18791 15.2753 5.6668 14.4655 6.64463Z",
    fill: "#00C2FF",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.09399,
    y: 10.5758,
    width: 4.73939,
    height: 4.73939,
    fill: "white",
    stroke: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25_1743"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaolueti);
export default __webpack_public_path__ + "static/media/saolueti.5a45e63a359aa73714341a0c4c7252e8.svg";
export { ForwardRef as ReactComponent };